<template>
  <div class="fab-container">
    <div id="copy-modal" class="uk-modal" uk-modal stack>
      <div
        class="
          uk-modal-dialog uk-modal-body uk-margin-auto-vertical
          custom-modal
        "
        style="text-align: center"
      >
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <p>網址已複製完成</p>
      </div>
    </div>
    <ul class="fab-options">
      <li>
        <div class="fab-icon-holder" @click="copyURLToClipboard">
          <img src="https://pics.seeds.com.tw/blog/paste_icon.svg" />
        </div>
      </li>
      <li>
        <div class="fab-icon-holder" @click="urlShare('FB')">
          <img src="https://pics.seeds.com.tw/blog/fb_icon.svg" />
        </div>
      </li>
      <li>
        <div class="fab-icon-holder" @click="urlShare('LINE')">
          <img src="https://pics.seeds.com.tw/blog/line_icon.svg" />
        </div>
      </li>
    </ul>
    <div class="fab-icon-holder">
      <img src="https://pics.seeds.com.tw/blog/share_icon.svg" />
    </div>
  </div>
</template>
<script>
import UIkit from "uikit";
export default {
  name: "FloatActionButton",
  methods: {
    urlShare(mediaType) {
      let mediaShareLink = "";
      if (mediaType === "FB") {
        mediaShareLink = this.fbShareLink;
      } else if (mediaType === "LINE") {
        mediaShareLink = this.lineShareLink;
      }
      if (navigator.share) {
        navigator
          .share({
            url: window.location.href,
          })
          .catch((error) => {
            if (error.name != "AbortError") {
              window.open(mediaShareLink, "_blank").focus();
            }
          });
      } else {
        window.open(mediaShareLink, "_blank").focus();
      }
    },
    copyURLToClipboard() {
      const el = document.createElement("textarea");
      el.value = window.location.href;
      document.body.appendChild(el);
      if (navigator.userAgent.match(/ipad|iphone/i)) {
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNode(el);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        el.select();
      }
      const res = document.execCommand("copy");
      el.remove();
      UIkit.modal(document.getElementById("copy-modal")).show();
      return res;
    },
  },
  computed: {
    fbShareLink() {
      return (
        "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href
      );
    },
    lineShareLink() {
      return "https://lineit.line.me/share/ui?url=" + window.location.href;
    },
  },
};
</script>
<style lang="scss" scoped>
.fab-container {
  position: fixed;
  right: 20px;
  bottom: 20px;
  cursor: pointer;
  @media (min-width: 640px) and (max-width: 1119.98px) {
    right: 56px;
    bottom: 56px;
  }
  @media (min-width: 1120px) {
    right: 56px;
    bottom: 56px;
  }
}
.fab-container:hover ul.fab-options {
  visibility: visible;
  opacity: 1;
}
.fab-options li {
  list-style: none;
  margin-bottom: 10px;
}
ul.fab-options {
  padding: 0;
  margin: 0;
  visibility: hidden;
  opacity: 0;
  transition: visibility 1s, opacity 0.3s linear;
}
.fab-icon-holder {
  width: 41px;
  height: 41px;

  @media (min-width: 640px) and (max-width: 1119.98px) {
    width: 56px;
    height: 56px;
  }
  @media (min-width: 1120px) {
    width: 56px;
    height: 56px;
  }
}
</style>